<template>
    <attended-interview-listing :is-admin="true"/>
</template>
<script>
import AttendedInterviewListing from '../../common-components/AttendedInterviewListing';
export default {
    components: { AttendedInterviewListing }
};
</script>
